import { useState, useEffect } from 'react';
import { listSettings } from '../Dashboard/api/Api';
import { NotificationService } from '../Utils/NotificationService';

export const useNotifications = (pageName) => {
  const [notifications, setNotifications] = useState([]);
  const [popupNotifications, setPopupNotifications] = useState([]);
  const [marqueeNotifications, setMarqueeNotifications] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch notifications from API
  const fetchNotifications = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await listSettings();
      // console.log('Full API Response:', response);
      
      const data = Array.isArray(response?.data?.data) ? response.data.data : [];
      // console.log('Notifications data:', data);
      // console.log('Current page name:', pageName);
      
      setNotifications(data);
      
      // Filter notifications for the current page
      if (pageName) {
        const popups = NotificationService.filterNotifications(data, pageName, 'popup');
        const marquees = NotificationService.filterNotifications(data, pageName, 'marquee');
        
        // console.log('Filtered popups for', pageName, ':', popups);
        // console.log('Filtered marquees for', pageName, ':', marquees);
        
        setPopupNotifications(popups);
        setMarqueeNotifications(marquees);
      }
      
    } catch (err) {
      setError('Failed to fetch notifications');
      // console.error('Notification fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    
    // Expose clear function to window for testing
    if (typeof window !== 'undefined') {
      window.clearNotificationCookies = () => {
        NotificationService.clearAllNotificationCookies();
        // console.log('All notification cookies cleared. Refreshing notifications...');
        fetchNotifications();
      };
    }
  }, [pageName]);

  // Mark notification as shown (used when popup/marquee is closed)
  const markNotificationAsShown = (notification) => {
    NotificationService.markAsShown(notification);
    
    // Only remove popup notifications from current arrays
    // Marquee notifications should continue showing even after being "marked as shown"
    const notificationType = notification.pageType || notification.type;
    
    if (notificationType === 'popup') {
      setPopupNotifications(prev => 
        prev.filter(n => (n.id || n._id) !== (notification.id || notification._id))
      );
    }
    
    // Note: We don't remove marquee notifications as they should continue running
  };

  // Get notifications for specific page and type
  const getNotificationsForPage = (targetPageName, pageType) => {
    return NotificationService.filterNotifications(notifications, targetPageName, pageType);
  };

  return {
    notifications,
    popupNotifications,
    marqueeNotifications,
    loading,
    error,
    fetchNotifications,
    markNotificationAsShown,
    getNotificationsForPage
  };
};